// TODO: this component is a mess and probably should be rewritten from scratch

import * as Sentry from '@sentry/react';
import { isSessionSpeeddate } from 'common-data-handling';
import React, { useCallback, useState } from 'react';
import tinycolor from 'tinycolor2';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import { useUserSchedule } from '../../../../../data/hooks/schedule/useUserSchedule';
import { useSessionSpeakers } from '../../../../../data/hooks/speakers/useSessionSpeakers';
import { dialogConfirm } from '../../../../elements/Dialog/dialogs';
import Icon from '../../../../elements/icons/Icon';
import Location from '../../../../elements/Location';
import ProgramListItem from '../../../../elements/ProgramListItem';
import FavoritedBand from '../../EventScheduleItemScreen/elements/ScheduleSessionBaseInfo/FavoritedBand';
import FullTag from '../FullTag/FullTag';
import handleChooseSession from '../handleChooseSession';
import handleDeselectSession from '../handleDeselectSession';
import styles from './ProgramItem.module.scss';

const FILTER_SELECTED_SESSIONS = (session) => session.is_selected;

const ProgramItem = (props) => {
    const { item, round, event, className = '', style: customStyle, onSessionSelectionChange, nextIcon: forceNextIcon } = props,
        i18n = useI18n(),
        otherSelections = useUserSchedule(event.id, {
            filter: FILTER_SELECTED_SESSIONS,
        }),
        speakers = useSessionSpeakers(event.id, item.id),
        featuredSpeakers = speakers.filter(s => s.featured_in_schedule),
        classes = [className],
        itemProps = {
            startTime: item.start_local,
            endTime: item.end_local,
        },
        [busy, setBusy] = useState(false);

    // Event handlers
    const handleItemClicked = useCallback(() => {
            // app.history.push(['/events', event.id, 'schedule', eventMomentFactory(event, item.start_local).format(DATE_FORMAT_URL), item.id].join('/'));
            app.history.push(['.', item.id].join('/'));
        }, [event, item]),
        handleSelectableSessionClicked = useCallback(
            (e) => {
                e.stopPropagation();
                if (!busy) {
                    handleChooseSession(i18n, event.id, item, otherSelections, {
                        onStart: () => {
                            setBusy(true);
                        },
                        onEnd: () => {
                            setBusy(false);
                        },
                    });
                    if (onSessionSelectionChange) {
                        onSessionSelectionChange(item);
                    }
                }
            },
            [i18n, event, item, otherSelections, onSessionSelectionChange, busy]
        ),
        handleSelectedSessionClicked = useCallback(
            async (e) => {
                e.stopPropagation();
                if (!busy) {
                    if (await dialogConfirm(i18n['label.confirmation-message'] + item.name + '?')) {
                        handleDeselectSession(event.id, item, {
                            onStart: () => {
                                setBusy(true);
                            },
                            onEnd: () => {
                                setBusy(false);
                            },
                        });
                        if (onSessionSelectionChange) {
                            onSessionSelectionChange(item);
                        }
                    }
                }
            },
            [i18n, item, event, busy]
        );

    // Render output
    let nextIcon = true,
        style = { ...customStyle },
        contentStyle = {},
        color = tinycolor(event.settings.secondary_color),
        bgColor = item.block_color || event.settings.secondary_color;

    if (item.display_type == 'break') {
        style = {
            ...style,
            backgroundColor: null,
            borderColor: item.block_color || event.settings.primary_color,
        };
        contentStyle = {
            ...contentStyle,
            color: item.block_color || event.settings.primary_color,
        };
        delete itemProps.endTime;
        nextIcon = false;
        itemProps.break = true;
        classes.push(styles.break);
    } else if (isSessionSpeeddate(item)) {
        itemProps.selectableColor = item.block_color || event.settings.primary_color;
        itemProps.tabIcon = <Icon src="/img/speeddate_icon.png" size={16} color="white" style={{ opacity: 0.5 }} />;
        style.borderBottom = '1px solid ' + (item.block_color || event.settings.primary_color);
    } else if (item.is_selected) {
        style.borderBottom = '1px solid ' + (item.block_color || event.settings.primary_color);
    } else if (!item.selectable && !round) {
        // console.log(item.name, item.display_type, item);
        style.borderBottom = '1px solid ' + (item.block_color || event.settings.primary_color);
        itemProps.selectableColor = item.block_color || event.settings.primary_color;
    }

    if (event.joined && item.is_selectable && event.settings.workshop_selection) {
        if (item.is_full) {
            itemProps.selectableColor = item.block_color || round?.block_color || bgColor;
            if (item.is_selected) {
                itemProps.selected = true;
                itemProps.selectable = true;
                itemProps.onSelectSession = handleSelectedSessionClicked;
            } else {
                itemProps.selectable = false;
            }
        } else if (item.is_selected) {
            itemProps.selectableColor = item.block_color || round?.block_color || bgColor;
            itemProps.selected = true;
            itemProps.selectable = true;
            itemProps.onSelectSession = handleSelectedSessionClicked;
        } else {
            itemProps.selectableColor = item.block_color || round?.block_color || bgColor;
            itemProps.selected = false;
            itemProps.selectable = true;
            itemProps.onSelectSession = handleSelectableSessionClicked;
        }
    } else if (!event.settings.workshop_selection && item.is_selected) {
        itemProps.selectableColor = item.block_color || round?.block_color || bgColor;
        itemProps.selected = true;
        itemProps.selectable = true;
        itemProps.onSelectSession = handleItemClicked;
    }

    return (
        <>
            <ProgramListItem
                className={classes.join(' ')}
                style={style}
                contentStyle={contentStyle}
                {...itemProps}
                nextIcon={forceNextIcon !== undefined ? forceNextIcon : nextIcon}
                onClick={handleItemClicked}>
                <p className="text name" style={contentStyle}>
                    {item.name}
                    <FullTag className="marginTop" session={item} />
                </p>
                {featuredSpeakers.length > 0 && item.display_type !== 'break' && item.display_type !== 'speeddate' ? (
                    <ul className="speakers">{featuredSpeakers.map((speaker, i) => (speaker.name ? <li key={i}>{speaker.name}</li> : null))}</ul>
                ) : null}
                <Location className={styles.location} color={item.block_color}>
                    {item.location}
                </Location>
                <FavoritedBand favorite={item.is_favorite} />
            </ProgramListItem>
        </>
    );
};

export default (props) => {
    const { item } = props;

    if (!item) {
        // This shouldn't happen: better report it
        console.warn('Attemping to render ProgramItem without a program item');
        Sentry.addBreadcrumb({
            message: `At ${location.pathname}`,
            data: props,
        });
        Sentry.captureMessage(`Attempting to render ProgramItem without a program item!`);
        return null;
    }

    return <ProgramItem {...props} />;
};
